import * as React from 'react';
import { composer } from '../../component-decorators/composer';
import { Box, SidebarSectionItem } from 'wix-style-react';
import { AppMarketLink } from '../app-market-link';
import { config } from '../../config';
import { Origin, Path } from '../../enums/marketplace-enums';
import { biLogger } from '../../bi';
import s from './menu-item.scss';
export var HomeMenuItem = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, isSelected = _a.isSelected;
    var isPlatformSA = config.origin === Origin.STANDALONE;
    var marginTop = isPlatformSA ? '18px' : '0';
    var homeLabel = t('menu.home');
    var navigateTo = function () {
        biLogger.appMarketMenuNavigation({
            market: config.originForBI,
            menu_item_label: homeLabel,
        });
        config.goto({ path: Path.HOME, referral: 'menu_navigation' });
    };
    return (React.createElement(Box, { dataHook: 'home-menu-item', className: s.menuItem, marginTop: marginTop },
        React.createElement(SidebarSectionItem, { dataHook: "home-section-item", onClick: navigateTo, selected: isSelected },
            React.createElement(AppMarketLink, { to: Path.HOME, className: s.menuItemLink }, homeLabel))));
});
//# sourceMappingURL=home-menu-item.js.map